import { type PropsWithChildren } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { Navbar, NavbarBackLink, theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationFloatingControls = (props: Props) => {
  const {
    children,
    isLiquidGlassEnabled = false,
    shouldDisableControls,
    onBackButtonPress,
  } = props;

  const { formatMessage } = useIntl();
  const { currentBreakpoint } = useResponsive();

  // ─────────────────────────────────────────────────────────────────────

  const shouldRenderBackButton = currentBreakpoint.isXS;

  // ─────────────────────────────────────────────────────────────────────

  if (!shouldRenderBackButton) {
    return children;
  }

  return (
    <View style={styles.container}>
      <Navbar.LinksGroup isLiquidGlassEnabled={isLiquidGlassEnabled}>
        <NavbarBackLink
          accessibilityLabel={formatMessage(messages.backButtonA11yLabel)}
          disabled={shouldDisableControls}
          onPress={onBackButtonPress}
        />
      </Navbar.LinksGroup>

      <View style={styles.ctaContainer}>{children}</View>
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  backButtonA11yLabel: {
    defaultMessage: 'Go back',
    description: 'Customization | Floating controls | Back button label',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['4'],
  },
  ctaContainer: {
    flexShrink: 1,
    marginLeft: 'auto',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  isLiquidGlassEnabled?: boolean;
  shouldDisableControls?: boolean;
  onBackButtonPress: () => void;
}>;
